import React, { useCallback, useMemo } from 'react';
import i18next from 'i18next';
import Container from '../../StyledComponents/Container';
import { Repeat } from '../../StyledComponents/Repeat';
import { PageSection } from '../../StyledComponents/Page';
import SectionHeader from '../../StyledComponents/SectionHeader';
import OverflowGrid from '../../StyledComponents/OverflowGrid';
import ProductCard from '../ProductCard';
import { H2 } from '../../StyledComponents/Heading';
import useRelatedSearch from './State/RelatedSearch/useRelatedSearch';
import Loader from '../../StyledComponents/Loader';
import PubSub from '../../utils/PubsubItem';
import { toProductCard } from '../ProductCard/utils';
import useRelatedAds from '../../Gql/ad/useRelatedAds';
import useSettings from './State/Settings/useSettings';

interface RelatedProps {
  id: string;
  branchId: string;
  manufacturer?: string;
  href?: string;
  onClickSearchItem?: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: string,
    slug: string
  ) => void;
}

const Related = ({ id, branchId, manufacturer, href, onClickSearchItem }: RelatedProps) => {
  const { publicApi } = useSettings();
  const legacy = useRelatedSearch(id, !!publicApi);
  const gql = useRelatedAds(publicApi, id, manufacturer);
  const loading = publicApi ? gql.loading : legacy.loading;
  const response = publicApi ? gql.response : legacy.response;
  const moreLikeThisUrl = publicApi ? !!manufacturer : legacy.moreLikeThisUrl;

  const onItemClicked = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, _id: string, slug: string) => {
      PubSub.publish('ItemClicked', _id);
      if (onClickSearchItem) {
        onClickSearchItem(e, _id, slug);
      }
    },
    []
  );

  const displayBranchName = useMemo(
    () => !!response?.documentList.documents.some((d) => d.branches.some((x) => x.id !== branchId)),
    [response]
  );

  if (!response?.documentList.documents.length || response?.documentList.documents.length === 0) {
    return null;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <PageSection accent large>
      <Container>
        {moreLikeThisUrl ? (
          <Repeat>
            <SectionHeader onClick={() => {}}>
              <H2 noMargin>{i18next.t('item.relatedVehicles')}</H2>
            </SectionHeader>
          </Repeat>
        ) : (
          <Repeat>
            <SectionHeader onClick={() => {}} actionTitle="Visa alla">
              <H2 noMargin>{i18next.t('item.latestVehicles')}</H2>
            </SectionHeader>
          </Repeat>
        )}

        <Repeat>
          <OverflowGrid
            accentBg
            columns={1.05}
            columnsSm={2.1}
            columnsMd={3}
            spacing={2}
            items={response?.documentList.documents.map((document) => (
              <ProductCard
                key={document._id}
                onClick={onItemClicked}
                href={href || '/sok/id/'}
                headingLevel={3}
                {...toProductCard(document, displayBranchName)}
              />
            ))}
          />
        </Repeat>
      </Container>
    </PageSection>
  );
};

export default Related;
